import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSmashingmagazineComponent } from './simple-icons-smashingmagazine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSmashingmagazineComponent ],
    exports:      [ SimpleIconsSmashingmagazineComponent ],
    bootstrap:    []
})
export class SimpleIconsSmashingmagazineModule {}
